export const usePerPage = (): number => {
  return 25;
};
